<template>
<div class="app">
    <div class="header">
        <div class="icons-submenu">
            <div class="defaultheader icon-submenu" v-bind:class="{active: viewMode == 1}" @click="viewMode = 1">
                <div class="label">Bereiche</div>
            </div>
            <div class="defaultheader icon-submenu" v-bind:class="{active: viewMode == 2}" @click="viewMode = 2">
                <div class="label">Positionen</div>
            </div>
            <div class="defaultheader icon-submenu" v-bind:class="{active: viewMode == 3}" @click="viewMode = 3">
                <div class="label">Skills</div>
            </div>
             <div class="defaultheader icon-submenu last" v-bind:class="{active: viewMode == 4}" @click="viewMode = 4">
                <div class="label">Events & Feiertage</div>
            </div>
        </div>



        <div class="icons-submenu" style="margin-left:30px;">
            <div class="defaultheader icon-submenu" v-bind:class="{active: viewMode == 5}" @click="viewMode = 5">
                <div class="label">Plan Typen Muster</div>
            </div>
            <div class="defaultheader icon-submenu last" v-bind:class="{active: viewMode == 6}" @click="viewMode = 6">
                <div class="label">Freizeit Optionen Muster</div>
            </div>
        </div>

        <div class="icons-submenu" style="margin-left:30px;">
            <div class="defaultheader icon-submenu last" v-bind:class="{active: viewMode == 7}" @click="viewMode = 7">
                <div class="label">Benutzerrollen</div>
            </div>
        </div>

    </div>
    <b-container fluid class="scrollbar-container has-header-important">
        <b-row v-if="viewMode == 1">
            <b-col>
                <businessunit></businessunit>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 2">
            <b-col>
                <spot></spot>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 3">
            <b-col>
                <skills></skills>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 4">
            <b-col>
                <storeeventoverview></storeeventoverview>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 5">
            <b-col>
                <employeetypetemplateoverview></employeetypetemplateoverview>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 6">
            <b-col>
                <employeerulestemplateoverview></employeerulestemplateoverview>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 7">
            <b-col>
                <userroles></userroles>
            </b-col>
        </b-row>
        <br>
    </b-container>
</div>
</template>

<script>
import businessunit from '../storedatacontext/BusinessUnit.vue'
import spot from '../storedatacontext/Spot.vue'
import skills from '../storedatacontext/SkillOverview'
import storeeventoverview from '../storedatacontext/StoreEventOverview'

import employeetypetemplateoverview from '../storedatacontext/EmployeeTypeTemplateOverview.vue'
import employeerulestemplateoverview from '../storedatacontext/EmployeeRulesTemplateOverview.vue'

import userroles from '../rolecontext/Roles.vue'

export default {
    components: {
        businessunit, 
        spot,
        skills,
        storeeventoverview,
        employeetypetemplateoverview,
        employeerulestemplateoverview,
        userroles,
    },
    name: 'StoreMain',
    data() {
        return {
            viewMode: 7,
            loading: true,
        }
    },
    watch: {},
    props: {},
    created() {
        window.storemain = this;
        var settings = this;
    },
    mounted(){
        
    },
    updated() {},
    destroyed() {},
    methods: {
        
    }
}
</script>